<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="extra-large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="selectedUrl ? `/request/${inputs.id}` : '/request'"
      >
        <div class="row">
          <div class="col-md-12">
            <app-note
              class="mb-primary"
              title="Información"
              content-type="html"
              :notes="[
                'Si no identifica en la lista desplegable el alcance de acreditación que requiere solicitar al SAE, deberá contactarse primero con la Dirección de Acreditación del SAE respectivamente, para lo cual deberá enviar su requerimiento al correo <b>sisac@acreditacion.gob.ec</b> y de inmediato se contactarán con usted.',
              ]"
            />
          </div>

          <div class="col-12" v-if="['OICC', 'OEYC', 'OENY', 'OCLN'].includes(activity)">
            <div class="form-group">
              <label>Ubicación</label>
              <multiselect
                v-model="inputs.org_id"
                :options="orgs"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div>

          <div class="col-12" v-if="!['OENY', 'OEYC', 'OCLN'].includes(activity)">
            <div class="form-group">
              <label v-if="['OVV'].includes(activity)">Actividad</label>
              <label v-else>Sector</label>
              <multiselect
                v-model="inputs.level2"
                :options="scopes.level2"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div>

          <div class="col-12" v-if="level3">
            <div class="form-group">
              <label>{{ level3 }}</label>
              <multiselect
                v-model="inputs.level3"
                :options="scopes.level3"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div>

          <div class="col-12" v-if="level4">
            <div class="form-group">
              <label>{{ level4 }}</label>
              <multiselect
                v-if="!['OINSP'].includes(this.activity)"
                v-model="inputs.level4"
                :options="scopes.level4"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
              <app-input
                v-if="['OINSP'].includes(this.activity)"
                type="multi-select"
                :list="scopes.level4"
                :isAnimatedDropdown="true"
                v-model="inputs.level_4_selected"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12" v-if="level5">
            <div class="form-group">
              <label>{{ level5 }}</label>
              <multiselect
                v-if="!['OINSP', 'OCPE', 'OCPR', 'OVV'].includes(this.activity)"
                v-model="inputs.level5"
                :options="scopes.level5"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
              <app-input
                v-if="['OINSP', 'OCPE', 'OCPR', 'OVV'].includes(this.activity)"
                type="multi-select"
                :list="scopes.level5"
                :isAnimatedDropdown="true"
                v-model="inputs.level_5_selected"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12" v-if="level6">
            <div class="form-group">
              <label>{{ level6 }}</label>
              <multiselect
                v-if="!['OEYC', 'OCPR'].includes(this.activity)"
                v-model="inputs.level6"
                :options="scopes.level6"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
              <app-input
                v-if="['OEYC', 'OCPR'].includes(this.activity)"
                type="multi-select"
                :list="scopes.level6"
                :isAnimatedDropdown="true"
                v-model="inputs.level_6_selected"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12" v-if="level7">
            <div class="form-group">
              <label
                >{{ level7 }}
                <span
                  class="text-warning ml-2"
                  v-if="['OCPR'].includes(this.activity)"
                  >Si no aplica colocar N/A</span
                ></label
              >
              <!-- <app-input
                type="textarea"
                v-model="inputs.level7"
                :required="true"
                :placeholder="`Ingrese ${level7}`"
              /> -->
              <quill-editor v-model="inputs.level7" :options="editorOption" />
            </div>
          </div>
          <br /><br /><br /><br /><br />
          <div class="col-12" v-if="level7b">
            <div class="form-group">
              <label>{{ level7b }}</label>
              <multiselect
                v-if="!['OENY', 'OICC', 'OCLN', 'CSIA'].includes(this.activity)"
                v-model="inputs.level7b"
                :options="scopes.level7b"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
              <app-input
                v-if="['OENY', 'OICC', 'OCLN', 'CSIA'].includes(this.activity)"
                type="multi-select"
                :list="scopes.level7b"
                :isAnimatedDropdown="true"
                v-model="inputs.level_7_selected"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12" v-if="level8" style="margin-top: 90px">
            <div class="form-group">
              <label>{{ level8 }}</label>
              <!-- <app-input
                type="textarea"
                v-model="inputs.level8"
                :required="true"
                :placeholder="`Ingrese ${level8}`"
              /> -->
              <quill-editor v-model="inputs.level8" :options="editorOption" />
            </div>
          </div>
          <br /><br /><br /><br /><br />

          <div class="col-12" v-if="level8b">
            <div class="form-group">
              <label>{{ level8b }}</label>
              <multiselect
                v-if="!['OCPR'].includes(this.activity)"
                v-model="inputs.level8b"
                :options="scopes.level8b"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
              <app-input
                v-if="['OCPR'].includes(this.activity)"
                type="multi-select"
                :list="scopes.level8b"
                :isAnimatedDropdown="true"
                v-model="inputs.level_8_selected"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12" v-if="level9" style="margin-top: 90px">
            <div class="form-group">
              <label>{{ level9 }}</label>
              <!--
              <app-input
                type="textarea"
                v-model="inputs.level9"
                :required="true"
                :placeholder="`Ingrese el ${level9}`"
              />
              -->
              <quill-editor v-model="inputs.level9" :options="editorOption" />
            </div>
          </div>
          <br /><br /><br /><br /><br />

          <div class="col-12" v-if="level10" style="margin-top: 90px">
            <div class="form-group">
              <label>{{ level10 }}</label>
              <!--
              <app-input
                type="textarea"
                v-model="inputs.level10"
                :required="true"
                :placeholder="`Ingrese ${level10}`"
              /> -->
              <quill-editor v-model="inputs.level10" :options="editorOption" />
            </div>
          </div>
          <br /><br /><br /><br /><br />

          <div class="col-12" v-if="level11" style="margin-top: 90px">
            <div class="form-group">
              <label>{{ level11 }}</label>
              <!--
              <app-input
                type="textarea"
                v-model="inputs.level11"
                :required="true"
                :placeholder="`Ingrese ${level11}`"
              />
              -->
              <quill-editor v-model="inputs.level11" :options="editorOption" />
            </div>
          </div>
          <br /><br /><br /><br /><br />

          <div class="col-12" style="margin-top: 100px" v-if="showCondition">
            <div class="form-group">
              <label>Condición de Alcance </label>
              <app-input
                type="select"
                v-model="inputs.condicion_scope"
                :required="true"
                :list="condicionList"
                v-on:change="getResolution(inputs.condicion_scope)"
              />
            </div>
          </div>
          <div class="col-12" v-if="nameResolution=='Suspensión' || nameResolution=='Suspensión voluntaria' || nameResolution=='Retiro' || nameResolution=='Retiro voluntario' || nameResolution=='Reducción' || nameResolution=='Reducción voluntaria'">
            <div class="form-group">
              <label>Fecha a {{nameResolution}}
              </label>
              <app-input
                type="date"
                v-model="inputs.updated_at"
                :required="true"
              />
            </div>
          </div>

          <!--<div class="col-12" v-if="showObservation">-->
          <div class="col-12" style="margin-top: 90px">
            <div class="form-group">
              <label>Justificación</label>
              <!-- <app-input
                type="textarea"
                v-model="inputs.observation"
                :required="true"
                placeholder="Justifique el porque edita el alcance"
              />  -->
              <quill-editor
                v-model="inputs.observation"
                :options="editorOption"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import Multiselect from "vue-multiselect";
import { quillEditor } from "vue-quill-editor";

export default {
  components: { Multiselect, quillEditor },
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    selectedUrl: String,
    activity: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        level_4_selected: [],
        level_5_selected: [],
        level_6_selected: [],
        level_7_selected: [],
        level_8_selected: [],
      },
      scopes: {
        level2: [],
        level3: [],
        level4: [],
        level5: [],
        level6: [],
        level7b: [],
        level8b: [],
      },
      editorOption: {
        placeholder: "Inserte el texto aquí..",
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            [
              "bold",
              "italic",
              "underline",
              "strike",
              { color: [] },
              { background: [] },
            ],
            [{ align: [] }],
            [
              { list: "ordered" },
              { list: "bullet" },
              { indent: "-1" },
              { indent: "+1" },
            ],
            ["clean"],
          ],
        },
      },
      modalId: "add-edit-modal",
      disabledSubmit: false,
      orgs: [],
      condicionList: [],
      nameResolution: "",
      isResolution: 0,
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
    level3() {
      let tmp = null;
      if (
        ["OCPR", "CSGAS", "OCSG", "CSIA", "OCPE", "CSA", "CSDM", "CSST", "CSEN"].includes(this.activity)
      )
        tmp = "Norma de acreditación";
      else if (["OINSP"].includes(this.activity))
        tmp = "Campo de inspección/alcance";
      else if (["OENY", "OICC", "OCLN", "OEYC", "OVV"].includes(this.activity))
        tmp = "Categoría";
      return tmp;
    },
    level4() {
      let tmp = null;
      if (["OCPR"].includes(this.activity))
        tmp = "Producto, Proceso o Servicio";
      else if (["CSGAS", "OCSG", "CSIA", "CSA", "CSDM", "CSST", "CSEN"].includes(this.activity))
        tmp = "Norma de certificación";
      else if (["OCPE"].includes(this.activity)) tmp = "Personal certificado";
      else if (["OINSP"].includes(this.activity))
        tmp = "Elemento a inspeccionar";
      else if (["OENY"].includes(this.activity)) tmp = "Campo";
      else if (["OCLN"].includes(this.activity)) tmp = "Campo de Análisis";
      else if (["OICC"].includes(this.activity)) tmp = "Campo de Ensayo";
      else if (["OEYC"].includes(this.activity)) tmp = "Área Calibración";
      else if (["OVV"].includes(this.activity)) tmp = "Programa";
      return tmp;
    },
    level5() {
      let tmp = null;
      if (["OCSG", "CSA", "CSST"].includes(this.activity)) tmp = "Sector IAF";
      else if (["OCPR"].includes(this.activity))
        tmp = "Categoría de producto, Proceso o Servicio";
      else if (["CSIA"].includes(this.activity)) tmp = "Grupo";
      else if (["OCPE"].includes(this.activity)) tmp = "Categoría de personal";
      else if (["OINSP"].includes(this.activity))
        tmp = "Tipo de inspección o metodología";
      else if (["OENY", "OICC", "OCLN"].includes(this.activity))
        tmp = "Técnica";
      else if (["OEYC"].includes(this.activity)) tmp = "Magnitud";
      else if (["OVV"].includes(this.activity)) tmp = "Documento Normativo";
      else if (["CSDM"].includes(this.activity)) tmp = "Sector/Referencia";
      return tmp;
    },
    level6() {
      let tmp = null;
      if (["OCPE"].includes(this.activity)) tmp = "Documento normativo";
      else if (["OCPR"].includes(this.activity)) tmp = "Documento normativo";
      else if (["CSIA"].includes(this.activity)) tmp = "Categoría";
      else if (["OINSP"].includes(this.activity))
        tmp = "Tipo de Organismo en base a la independencia (A,B,C)";
      else if (["OENY", "OICC"].includes(this.activity)) tmp = "Ensayo";
      else if (["OCLN"].includes(this.activity)) tmp = "Análisis";
      else if (["OEYC"].includes(this.activity)) tmp = "Instrumento";
      else if (["OVV"].includes(this.activity)) tmp = "Sector";
      else if (["CSDM"].includes(this.activity)) tmp = "Actividad";
      return tmp;
    },
    level7() {
      let tmp = null;
      if (["OCPE"].includes(this.activity))
        tmp = "Esquema de certificaciòn de personas";
      else if (["OCPR"].includes(this.activity))
        tmp = "Modificatorias a los Documentos Normativos";
      else if (["OINSP"].includes(this.activity))
        tmp = "Procedimientos de Inspección";
      else if (["OEAP"].includes(this.activity)) tmp = "Programa";
      else if (["OEYC"].includes(this.activity)) tmp = "Intervalo";
      return tmp;
    },
    level7b() {
      let tmp = null;
      if (["CSIA"].includes(this.activity)) tmp = "Subcategoría";
      else if (["OENY", "OICC"].includes(this.activity)) tmp = "Producto";
      else if (["OCLN"].includes(this.activity)) tmp = "Muestra";
      return tmp;
    },
    level8() {
      let tmp = null;
      if (["OINSP"].includes(this.activity))
        tmp =
          "Código tipo de la norma o especificación técnica/Vigencia de la norma o especificación técnica (Año de publicación, reafirmación, edición/revisión (cuando aplique))";
      else if (["OENY"].includes(this.activity)) tmp = "Rango";
      else if (["OEYC"].includes(this.activity)) tmp = "Incertidumbre";
      else if (["OEAP"].includes(this.activity)) tmp = "Ensayo / Magnitud";
      return tmp;
    },
    level8b() {
      let tmp = null;
      if (["CSIA"].includes(this.activity))
        tmp = "Documento normativo específico para FSSC";
      else if (["OCPR"].includes(this.activity))
        tmp = "Tipo de esquema de certificación";
      return tmp;
    },
    level9() {
      let tmp = null;
      if (["OCPR"].includes(this.activity)) tmp = "Especificación técnica";
      else if (["OENY", "OICC", "OEYC"].includes(this.activity))
        tmp = "Método Interno";
      else if (["OCLN"].includes(this.activity)) tmp = "Método de Análisis";
      else if (["OEAP"].includes(this.activity))
        tmp = "Ítem de Ensayo de Aptitud";
      return tmp;
    },
    level10() {
      let tmp = null;
      if (["OENY", "OICC", "OEYC"].includes(this.activity))
        tmp = "Método Referencia";
      else if (["OCLN"].includes(this.activity)) tmp = "Procedimiento";
      else if (["OEAP"].includes(this.activity)) tmp = "Frecuencia";
      return tmp;
    },
    level11() {
      let tmp = null;
      if (["OEAP"].includes(this.activity)) tmp = "Método para el Valor";
      return tmp;
    },
    showObservation() {
      let result = false;
      if (
        (this.selectedUrl &&
          this.$store.state.accreditation.currentStatus &&
          !this.inputs.status) ||
        (this.$store.state.accreditation.currentStatus &&
          this.inputs.status &&
          this.inputs.status.code !=
            this.$store.state.accreditation.currentStatus)
      ) {
        result = true;
      }
      return result;
    },
    showCondition() {
      let res = false;
      if (this.$store.state.accreditation.currentStatus == 620 || this.$store.state.accreditation.currentStatus == 621) {
        res = true;
      }
      return res;
    },
  },
  created() {
    this.getResolutionList();
    this.getData();
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      const tmp = {
        ...this.inputs,
        acc_app_id: this.$store.state.accreditation.id,
        status: this.$store.state.accreditation.currentStatus,
        acc_activity_id: this.$store.state.accreditation.app.accreditation_activity_id,
      };
      tmp.org_id = this.getId(tmp.org_id);
      if (["OENY"].includes(this.activity)) {
        tmp.level2 = 1865;
      } else if (["OEYC"].includes(this.activity)) {
        tmp.level2 = 759;
      } else if (["OCLN"].includes(this.activity)) {
        tmp.level2 = 509;
      } else {
        tmp.level2 = this.getId(tmp.level2);
      }
      tmp.level3 = this.getId(tmp.level3);
      tmp.level4 = this.getId(tmp.level4);
      tmp.level5 = this.getId(tmp.level5);
      tmp.level6 = this.getId(tmp.level6);
      tmp.level7b = this.getId(tmp.level7b);
      tmp.level8b = this.getId(tmp.level8b);
      tmp.is_resolution = this.isResolution;

      // Validar multi-select
      if (
        (this.level2 && !tmp.level2) ||
        (this.level3 && !tmp.level3) ||
        (this.level4 && !(tmp.level4 || tmp.level_4_selected.length > 0)) ||
        (this.level5 && !(tmp.level5 || tmp.level_5_selected.length > 0)) ||
        (this.level6 && !(tmp.level6 || tmp.level_6_selected.length > 0)) ||
        (this.level7b && !(tmp.level7b || tmp.level_7_selected.length > 0)) ||
        (this.level8b && !(tmp.level8b || tmp.level_8_selected.length > 0))
      ) {
        this.$toastr.e("Todos los campos son obligatorios");
        return;
      }

      if (this.isResolution && !tmp.updated_at) {
        this.$toastr.e("Todos los campos son obligatorios");
        return;
      }

      this.disabledSubmit = true;
      this.save(tmp);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      // this.$toastr.s(response.data.message);
      if (this.inputs.id) {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }

      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.preloader = false;

      const tmp = {};
      tmp.id = response.data.id;
      tmp.status = response.data.status;
      tmp.observation = response.data.observation;
      tmp.org_id = response.data.org;
      if (!tmp.org_id) {
        tmp.org_id = { id: null, value: "Matriz" };
      }
      tmp.condicion_scope = response.data.condicion_scope;

      tmp.level2 = response.data.level_2;
      tmp.level3 = response.data.level_3;
      tmp.level4 = response.data.level_4;
      tmp.level5 = response.data.level_5;
      tmp.level6 = response.data.level_6;
      tmp.level7 = response.data.level7;
      tmp.level7b = response.data.level_7b;
      tmp.level8 = response.data.level8;
      tmp.level8b = response.data.level_8b;
      tmp.level9 = response.data.level9;
      tmp.level10 = response.data.level10;
      tmp.level11 = response.data.level11;
      this.getResolution(response.data.condicion_scope);
      tmp.updated_at = new Date(response.data.updated_at);

      tmp.level_4_selected = response.data.level_4_selected.map(
        (item) => item.acc_scope_master_id
      );
      tmp.level_5_selected = response.data.level_5_selected.map(
        (item) => item.acc_scope_master_id
      );
      tmp.level_6_selected = response.data.level_6_selected.map(
        (item) => item.acc_scope_master_id
      );
      tmp.level_7_selected = response.data.level_7_selected.map(
        (item) => item.acc_scope_master_id
      );
      tmp.level_8_selected = response.data.level_8_selected.map(
        (item) => item.acc_scope_master_id
      );

      this.inputs = tmp;
    },

    getData() {
      this.preloader = true;

      this.axiosGet(
        `request/options?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            const {
              data: { scopes },
            } = response;
            this.scopes = scopes;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });

      this.axiosGet(
        `request/options?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            const {
              data: { orgs },
            } = response;
            this.orgs = [{ id: null, value: "Matriz" }, ...orgs];
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    getId(item) {
      return item ? item.id : null;
    },
    
    getResolution(id) {
      this.isResolution = 0;
      this.axiosGet(
        `request/resolutionTypes/${id}`
      )
        .then((response) => {
             this.nameResolution = response.data.name;

             if (this.nameResolution=='Suspensión' || this.nameResolution=='Suspensión voluntaria' || this.nameResolution=='Retiro' || this.nameResolution=='Retiro voluntario') {
                this.isResolution = 1;
             } else {
                this.isResolution = 0;
             }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
      return this.nameResolution;
    },

    getResolutionList() {
      this.axiosGet("/resolutionList").then((resp) => {
        this.condicionList = resp.data;
      });
    },
  },
};
</script>
